module.exports = __webpack_public_path__ + "static/media/schedule_structure_unset_rotating_periods.40c0c0e6.mov";